export default function imageLoader({
  quality,
  src,
  width,
}: {
  quality: any;
  src: string;
  width: any;
}) {
  return `${src}?w=${width}&q=${quality || 75}`;
}

export function replaceImageStorage(src: string | undefined) {
  return src?.replace(
    'https://talents-storage-images.platform.iglu.net/',
    'https://images.talentprofile.net/',
  );
}
